import "./adjectifsCvTwo.scss"
import ThemeCvDto from "../../../../../api/models/cvTheme"
import CvSkillDto from "../../../../../api/models/cvskill"
import logoTipeo from "../../../../../resources/images/LOGO_TIPEO_V1.png"

interface AdjectifsCvTwoProps {
	theme?: ThemeCvDto | null
	cvSkill: CvSkillDto
}

function AdjectifsCvTwo({ theme, cvSkill }: AdjectifsCvTwoProps) {
	const getAdjs = (): string[] => [
		...(cvSkill?.polePersonnaliteTraits?.map(
			element => element.personnaliteTrait,
		) || []),
		...(cvSkill?.polePersonnalitesTypes?.flatMap(
			element => element.associatedTraits,
		) || []),
	]

	const adjs = getAdjs()
	const adjectifsTexts1 = adjs.slice(0, 3)
	const adjectifsTexts2 = adjs.slice(3, 5)
	const adjectifsTexts3 = adjs.slice(5, 7)

	const adjectifsColors1 = ["white", "black", theme?.infoColorName || "#000"]
	const adjectifsColors3 = [theme?.infoColorText || "#000", "white"]

	const imageList1 = [
		theme?.infoImgBackground,
		theme?.adjImgBackground,
		theme?.adjColorBackground,
	]
	const imageList2 = [theme?.adjColorText2, theme?.adjColorText3]
	const imageList3 = [theme?.adjColorText1, theme?.adjImgBackground]

	return (
		<div className="adjectifs-two">
			<div
				className="adjectifs-two-bg"
				style={{
					backgroundImage: `url("${theme?.imagePrincipale}")`,
				}}
			/>

			<img src={logoTipeo} alt="Logo" className="adjectifs-two-logo" />

			<div className="adjectifs-two-content">
				<div className="adjectifs-two-group group-1">
					{imageList1.map((filename, index) => (
						<div className="adjectif-two-item" key={filename}>
							<img
								src={`${filename}`}
								alt={`Decoration ${index + 1}`}
								className="adjectifs-two-shape"
							/>
							<span
								className="adjectifs-two-label"
								style={{ color: adjectifsColors1[index] }}
							>
								{adjectifsTexts1[index]}
							</span>
						</div>
					))}
				</div>

				<div className="adjectifs-two-group group-2">
					{imageList2.map((filename, index) => (
						<div className="adjectif-two-item" key={filename}>
							<img
								src={`${filename}`}
								alt={`Decoration ${index + 1}`}
								className="adjectifs-two-shape"
							/>
							<span className="adjectifs-two-label text-white">
								{adjectifsTexts2[index]}
							</span>
						</div>
					))}
				</div>

				<div className="adjectifs-two-group group-3">
					{imageList3.map((filename, index) => (
						<div className="adjectif-two-item" key={filename}>
							<img
								src={`${filename}`}
								alt={`Decoration ${index + 1}`}
								className="adjectifs-two-shape"
							/>
							<span
								className="adjectifs-two-label"
								style={{ color: adjectifsColors3[index] }}
							>
								{adjectifsTexts3[index]}
							</span>
						</div>
					))}
				</div>
			</div>
		</div>
	)
}

export default AdjectifsCvTwo
